import { Component, Prop, Ref, log, useProp } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

import './ErrorPage.scss';

@Component
export class ErrorPage extends ThemeComponent {

}
